export const WIN_MESSAGES = ['łax̣aʔƛ̓as!']
